import {useLocation, useNavigate} from "react-router-dom";


const Splash = () => {
    const navigate = useNavigate()
    const location = useLocation()

    if (location.state){
        localStorage.clear()
        navigate("/login")
    }

    if (localStorage.getItem("token") != null){
        let s = setInterval(() => {
                navigate("/home");
                clearInterval(s)
            },5000
        );
    } else {
        let s = setInterval(() => {
                navigate("/login");
                clearInterval(s)
            },5000
        );
    }

    return (
        <div className="RootView">
            <div className="RootWidth">
                <div className="SplashDiv paymentStatusDiv">
                    <img className="logoIcon" alt="" src="../images/fail_img.png" />
                    <p className="phead">Transaction Failed. Don’t worry</p>
                    <p className="psub">If deducted then your money will be refunded to your account in 2-3 working days</p>
                </div>
            </div>
        </div>
    );
};

export default Splash;
